import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
        routes: [
            { path: '/', redirect: '/login' },
            {
                path: '/login',
                name: 'login',
                meta: {},
                // 进入/login 地址 判断 2020/6/09 
                beforeEnter: (to, from, next) => {
                    if (to.name === 'login') {
                        // 判断是否存在已登录
                        if (localStorage.getItem("AS_token") && localStorage.getItem("AS_token").length > 0 && localStorage.getItem("AS_token")) {
                            // 判断来源
                            if (from.name === null) {
                                next({ name: 'product' })
                            } else {
                                next(false)
                            }
                        } else {
                            next()
                        }
                    }
                },
                component: (resolve) => require(['./layouts/Login.vue'], resolve)
            },
            {
                path: '/main',
                name: 'main',
                component: (resolve) => require(['./layouts/Main.vue'], resolve),
                children: [{
                        path: '/product',
                        name: 'product',
                        component: (resolve) => require(['./views/product.vue'], resolve)
                    },
                    /*{
                              path: '/device',
                              name: 'device',
                              component: (resolve) => require(['./views/device.vue'], resolve)
                            },*/
                    {
                        path: '/customer',
                        name: 'customer',
                        component: (resolve) => require(['./views/customer.vue'], resolve)
                    }, {
                        path: '/admin',
                        name: 'admin',
                        component: (resolve) => require(['./views/admin.vue'], resolve)
                    }, {
                        path: '/complexMedia',
                        name: 'complexMedia',
                        component: (resolve) => require(['./views/complexMedia.vue'], resolve)
                    }, {
                        path: '/server',
                        name: 'server',
                        component: (resolve) => require(['./views/server.vue'], resolve)
                    }, {
                        path: '/systemLog',
                        name: 'systemLog',
                        component: (resolve) => require(['./views/systemLog.vue'], resolve)
                    }, {
                        path: '/codeLog',
                        name: 'codeLog',
                        component: (resolve) => require(['./views/codeLog.vue'], resolve)
                    }, {
                        path: '/msgManage',
                        name: 'msgManage',
                        component: (resolve) => require(['./views/msgManage.vue'], resolve)
                    }
                ],
            }
        ]
    })
    /**
     * 重写路由的push方法
     */
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    // return ( () => {
    // const push = routerPush.bind(this)
    // try {
    //     // console.log(location)
    //     push(location)
    // }
    // catch(err){
    //     console.log(err)
    // }
    // })()
    return routerPush.call(this, location, null, (err) => err);
};
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
    return originalReplace.call(this, location, null, (err) => err);
};